import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, Switch } from 'antd';
import Toast from 'antd-mobile/lib/toast';
import './UpdateChatIntent.css';

@inject('chatIntentStore')
@observer
class UpdateChatIntentModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    createChatIntentOnClick = () => {
        this.props.chatIntentStore.createChatIntent();
    }

    updateChatIntentOnClick = () => {
        this.props.chatIntentStore.updateChatIntent();
    }

    cancelChatIntentOnClick = () => {
        this.props.chatIntentStore.setShowUpdateChatIntentModal(false);
    }

    render() {
        const {
            chatIntentID,
            intentName,
            answer,
            isQna,
            hasRedirectUrl,
            intentRedirectName,
            intentRedirectUrl,
            updateLoading
        } = this.props.chatIntentStore;

        let hasError = false;
        if (isQna) {
            hasError = intentName !== '' && answer !== '';
        } else {
            if (hasRedirectUrl) {
                hasError = intentName !== '' && intentRedirectName !== '' && intentRedirectUrl !== '';
            } else {
                hasError = intentName !== '' && intentRedirectName !== '';
            }
        }

        if (updateLoading) {
            Toast.loading('Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <Form layout='vertical'>
                <Form.Item label='Intent Name' className='mg-b-10'>
                    <Input placeholder='Insert Intent Name' value={intentName} onChange={(e) => this.props.chatIntentStore.setIntentName(e.target.value)} />
                </Form.Item>

                <Form.Item label='Is Question Answer?' className='mg-b-10'>
                    <Switch checkedChildren='Yes' unCheckedChildren='No' checked={isQna} onChange={(value) => this.props.chatIntentStore.setIsQna(value)} />
                </Form.Item>

                <>
                    {
                        isQna
                            ?
                            <Form.Item label='Answer' className='mg-b-10'>
                                <Input placeholder='Insert Answer' value={answer} onChange={(e) => this.props.chatIntentStore.setAnswer(e.target.value)} />
                            </Form.Item>
                            :
                            <>
                                <Form.Item label='Confirmation Info' className='mg-b-10'>
                                    <Input placeholder='Insert Confirmation Info' value={intentRedirectName} onChange={(e) => this.props.chatIntentStore.setIntentRedirectName(e.target.value)} />
                                </Form.Item>
                                <Form.Item label='Need Redirect URL?' className='mg-b-10'>
                                    <Switch checkedChildren='Yes' unCheckedChildren='No' checked={hasRedirectUrl} onChange={(value) => this.props.chatIntentStore.setHasRedirectUrl(value)} />
                                </Form.Item>
                                <>
                                    {
                                        hasRedirectUrl
                                            ?
                                            <Form.Item label='Intent Redirect URL' className='mg-b-10'>
                                                <Input placeholder='Insert Intent Redirect URL' value={intentRedirectUrl} onChange={(e) => this.props.chatIntentStore.setIntentRedirectUrl(e.target.value)} />
                                            </Form.Item>
                                            :
                                            null
                                    }
                                </>
                            </>
                    }
                </>

                <Form.Item>
                    {
                        chatIntentID === 0 ? (
                            <Button onClick={this.createChatIntentOnClick} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>Create</Button>
                        ) : (
                            <Button onClick={this.updateChatIntentOnClick} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>Update</Button>
                        )
                    }

                    <Button onClick={this.cancelChatIntentOnClick}>Cancel</Button>
                </Form.Item>
            </Form>
        )
    }
}

export default UpdateChatIntentModal
